import React from 'react';
import { PUBLIC_URL, DOC_URL } from '../constants';
import { H3, H4 } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';


const Help = (props) => {
  const {t}=props;

  return (
    <>
    <div className="Home__wrapper">
        <img
          src={process.env.PUBLIC_URL + '/assets/img/lexicoscope.png'}
          alt="Lexicoscope"
          className="largeLogo"
        />

        <section>
          <H3>{t('help')}</H3>
        </section>

        <section>
          <H4>{t('videoTutorial')}</H4>
          <ul>
            <li>{t('presentation')} {'(13 min.)'} <a href={PUBLIC_URL+"/doc/1. Presentation generale (13 min).mkv"}>[version MKV]</a> <a href="https://youtu.be/mdLVgrEVVTY">[version Youtube]</a></li>
            <li>{t('simpleQuery')} {'(18 min.)'} <a href={PUBLIC_URL+"/doc/2. Requete simple (18 min).mkv"}>[version MKV]</a> <a href="https://youtu.be/PJKEdc65dgs">[version Youtube]</a></li>           
            <li>{t('advancedQuery')} {'(30 min.)'} <a href={PUBLIC_URL+"/doc/3. Requete avancee (30 min).mkv"}>[version MKV]</a> <a href="https://youtu.be/BUOgjHION5g">[version Youtube]</a></li>           
            <li>{t('searchSpecificVocabulary')} {'(17 min.)'} <a href={PUBLIC_URL+"/doc/4. Vocabulaire specifique (17 min).mkv"}>[version MKV]</a> <a href="https://youtu.be/8s8t570hztk">[version Youtube]</a></li>           
            <li>{t('customCorpus')} {'(9 min.)'} <a href={PUBLIC_URL+"/doc/5. Corpus personnalise (9 min).mkv"}>[version MKV]</a> <a href="https://youtu.be/VX6plTVyW8Q">[version Youtube]</a></li>           
          </ul>
        </section>

        <section>
          <H4>{t('termDefinition')}</H4>
          <ul>
            <li><strong>{t('frequency')}</strong><br/>{t('freqHelp')}</li>             
            <li><strong>{t('dispersion')}</strong><br/>{t('dispHelp')}</li>                       
            <li><strong>{t('specificity')}</strong><br/>{t('specHelp')}</li>
            <li><strong>{t('realization')}</strong><br/>{t('realHelp')}</li>
            <li><strong>{t('associationMeasure')}</strong><br/>{t('assocHelp')}</li> 
            <li><strong>{t('udTagSetLink')}</strong><br/>
              <a href='https://universaldependencies.org/u/pos/index.html'>{t('upos')}</a>, 
              <a href='https://universaldependencies.org/u/rel/index.html'>{t('deprel')}</a>
          
            </li>          
          </ul>
        </section>

        <section>
          <H4>{t('aboutCooccurrenceAndWordsketchesTitle')}</H4>
          <p>{t('aboutCooccurrenceAndWordsketches')}</p>
        </section>

        <section>
          <H4>{t('referenceTQLColon')} :
            <a href={PUBLIC_URL+DOC_URL+'/Reference TQL.fr.pdf'} target='blank'> [FR]</a> 
            <a href={PUBLIC_URL+DOC_URL+'/Reference TQL.en.pdf'} target='blank'> [EN]</a>
          </H4>
        </section>


        <section>
          <H4>{t('devTeam')}</H4>
          <ul>
            <li>{t('interface')} {'Olivier Kraif, Johan Didier & Nathan De Maestri.'}</li>
            <li>{t('searchEngine')} {'Olivier Kraif'}</li>           
            <li>{t('multivariateAnalysis')} {'Sascha Diwersy'}</li>             
            <li>{t('funding')} {'ANR - DFG - Université Grenoble Alpes'}</li>                       
          </ul>
        </section>

        <section>
          <H4>{t('ref2cite')}</H4>
          <ul>
            <li>{t('reference1')}</li>
            <li>{t('reference2')}</li>           
            <li>{t('reference3')}</li>             
            <li>{t('reference4')}</li>                       
         
          </ul>
        </section>

        <section>
          <H4>{t('credits')}</H4>
          <ul>
            <li>{t('stanza')}</li>
            <li>{t('termostat')}</li>
          </ul>
        </section>

      </div>
    </>
  );
}
export default withTranslation()(Help);